import { combineReducers } from 'redux';
import shopReducer from './shop_reducer';
import wallConfigReducer from './wall_config_reducer';
import settingsReducer from './settings_reducer';
import productsReducer from './products_reducer';
import backgroundsReducer from './backgrounds_reducer';
import framesReducer from './frames_reducer';
import faqsReducer from './faqs_reducer';

export default combineReducers({
  shop: shopReducer,
  wallConfig: wallConfigReducer,
  settings: settingsReducer,
  products: productsReducer,
  backgrounds: backgroundsReducer,
  frames: framesReducer,
  faqs: faqsReducer
})

